import { TextCodes } from '@api/types/translation/TextCodes';
import LocationOffIcon from '@mui/icons-material/LocationOff';
import PinDropIcon from '@mui/icons-material/PinDrop';
import { Button, ButtonProps, Tooltip } from '@mui/material';
import { AppDispatch } from '@store';
import { LocationState, fetchUserLocation, getUserLocation } from '@store/location/location.slice';
import { t } from '@translations';
import { useDispatch, useSelector } from 'react-redux';

type LocationButtonProps = {
  onClickEvent?: () => void;
  variant?: ButtonProps['variant'];
};

export const LocationButton = ({ onClickEvent, variant }: LocationButtonProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const locationState: LocationState = useSelector(getUserLocation);
  const isGranted = locationState.permission === 'granted';
  const onLocationSet = () => {
    if (locationState.permission === 'prompt') {
      dispatch(fetchUserLocation());
    }
    if (onClickEvent) {
      onClickEvent();
    }
  };

  const getIcon = () => {
    if (isGranted) {
      return <PinDropIcon />;
    }
    return <LocationOffIcon />;
  };

  return (
    <Tooltip
      title={
        isGranted
          ? t(TextCodes.Dealer.Find.DealersNearby)
          : t(TextCodes.ProductRequest.Order.EnableLocationServices)
      }
      placement='top'
      arrow
    >
      <Button onClick={onLocationSet} variant={variant} sx={{ minWidth: '40px !important' }}>
        {getIcon()}
      </Button>
    </Tooltip>
  );
};
